import React, { useEffect, useState } from 'react';
import { apiCall, getCategoryColor } from '../../utils';
import DoctorViewPatientMedicalRecord from './DoctorViewPatientMedicalRecord';
import moment from 'moment-timezone';


const DoctorServicePatientsView = ({
  isTabOpen = false, 
  branchId, 
  branchName,
  category,
  filterData,
  currentXhr,
  setCurrentXhr,
  businessPlans,
  businessServices,
  getBranchDoctorFromStaffId
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState({
    table1: []
  })
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [seelectedAgendaId, setSelectedAgendaId] = useState(null);

  const fetchFinancialReports = async () => {
    if (!branchId)
      return null;
    if (currentXhr) {
      currentXhr.abort();
      setCurrentXhr(false);
    }
    setIsLoading(true);
    let xhr = apiCall({
      method: 'GET',
      endpoint: 'api/v1/doctor/schedule/patients',
      data: {
        branch: branchId,
        category: category,
        startDate: filterData.startDate,
        endDate: filterData.endDate
      },
      successCallback: function(res) {
        setIsLoading(false);
        setCurrentXhr(false);
        if (res.error) {
          window.toast({
            error: res.error,
            text: res.message
          })
        } else {
          setTableData({
            table1: res.data
          });
        }
      },
      errorCallback: function(res) {
        setIsLoading(false);
        setCurrentXhr(false);
      }
    });
    setCurrentXhr(xhr);
  }

  const handlePatientMedicalRecordView = (patientId) => {
    setSelectedPatient(patientId);
  }

  useEffect(() => {
    if (isTabOpen) {
      setIsLoading(true);
      if (filterData.startDate && filterData.endDate) {
        setTableData({
          table1: []
        });
        fetchFinancialReports()
      }
    } else {
      setIsLoading(true);
    }
  }, [isTabOpen, filterData, branchId]);

  useEffect(() => {
    if (!isTabOpen) {
      setIsLoading(false);
      setSelectedPatient(null);
      setSelectedAgendaId(null);
      setTableData({
        table1: []
      });
    }
  }, [isTabOpen]);

  return (
    <div className="container-fluid p-4">
      {/* Cabeçalho */}
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <i className="fas fa-calendar-alt fa-2x text-primary me-3"></i>
            <div>
              <h4 className="mb-1">Agenda de Atendimentos</h4>
              <div className="text-muted small">
                <span className="me-3">
                  <i className="far fa-calendar me-1"></i>
                  {moment(filterData.startDate).tz('America/Sao_Paulo').format('DD/MM/YYYY')}
                </span>
                <span className="me-3">
                  <i className="fas fa-tag me-1"></i>
                  {category}
                </span>
                <span>
                  <i className="fas fa-clinic-medical me-1"></i>
                  {branchName}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Loading */}
      {isLoading ? (
        <div className="d-flex justify-content-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      ) : (
        <>
          {selectedPatient ? (
            <div className="card shadow-sm">
              <div className="card-body">
                <button 
                  className="btn btn-outline-primary mb-4"
                  onClick={() => {
                    setSelectedAgendaId(null);
                    setSelectedPatient(null);
                    setTableData({ table1: [] });
                    fetchFinancialReports();
                  }}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Voltar
                </button>
                <DoctorViewPatientMedicalRecord 
                  patientId={selectedPatient} 
                  agendaId={seelectedAgendaId} 
                  businessPlans={businessPlans} 
                  businessServices={businessServices}
                />
              </div>
            </div>
          ) : (
            <div className="card shadow-sm p-0 m-0">
              <div className="card-body p-0 m-0">
                  <table className="table table-hover align-middle table-striped table-bordered responsive-table">
                    <thead>
                      <tr>
                        <th style={{width: '120px'}}></th>
                        <th>ID</th>
                        <th>Quiro</th>
                        <th>Horário</th>
                        <th>Paciente</th>
                        <th>Conta</th>
                        <th>Tipo</th>
                        <th>Sessões restantes</th>
                        <th>Categoria</th>
                        <th>Atendimento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.table1.length === 0 ? (
                        <tr>
                          <td colSpan="10" className="text-center py-4 text-muted">
                            <i className="fas fa-inbox fa-2x mb-3 d-block"></i>
                            Nenhum registro encontrado
                          </td>
                        </tr>
                      ) : (
                        tableData.table1.map((row, index) => {
                          const clienteNome = row.CLIENTE_DADOS ? (row.CLIENTE_DADOS.split('|')[0] ?? '') : row.NOME_COMPLETO;
                          const clienteDataNascimento = row.CLIENTE_DADOS ? (row.CLIENTE_DADOS.split('|')[3] ?? '') : '';
                          const clienteIdade = clienteDataNascimento ? moment().diff(moment(clienteDataNascimento), 'years') : '';
                          
                          return (
                            <tr key={`row-${index + 1}`}>
                              <td data-label="Atender">
                                <button 
                                  type="button" 
                                  className="btn btn-sm btn-primary"
                                  onClick={() => {
                                    if (row.C_CORRENTE_ID == null) {
                                      return window.toast({
                                        error: true,
                                        text: 'Paciente sem conta corrente, aguarde o cadastro.'
                                      });
                                    }
                                    setSelectedPatient(row.CLIENTES_ID);
                                    setSelectedAgendaId(row.ID);
                                  }}
                                  disabled={!row.C_CORRENTE_ID}
                                >
                                  <i className="fas fa-clipboard me-2"></i>
                                  Atender
                                </button>
                              </td>
                              <td data-label="ID">{row.ID}</td>
                              <td data-label="Quiro">{getBranchDoctorFromStaffId(row.DOUTORES_ID)}</td>
                              <td data-label="Horário">
                                <div className="small">
                                  <div>{row.HORA_INICIO} - {row.HORA_FINAL}</div>
                                  <div className="text-muted">{row.DATA_INICIO}</div>
                                </div>
                              </td>
                              <td data-label="Paciente">
                                <div>{clienteNome}</div>
                                {clienteIdade && (
                                  <small className="text-muted">{clienteIdade} anos</small>
                                )}
                              </td>
                              <td data-label="Conta">{row.C_CORRENTE}</td>
                              <td data-label="Tipo">{row.TIPO_PACIENTE}</td>
                              <td data-label="Sessões restantes">
                                <span className="badge bg-info">
                                  {row.SESSOES_RESTANTES}
                                </span>
                              </td>
                              <td data-label="Categoria">
                                <span 
                                  className="badge" 
                                  style={{
                                    backgroundColor: getCategoryColor(row.CATEGORIA),
                                    cursor: 'default'
                                  }}
                                >
                                  {row.CATEGORIA}
                                </span>
                              </td>
                              <td data-label="Atendimento">
                                <div className="small">
                                  <div>
                                    <i className="fas fa-play-circle text-success me-1"></i>
                                    {row.ATENDIMENTO_INICIO_FORMAT || '-'}
                                  </div>
                                  <div>
                                    <i className="fas fa-stop-circle text-danger me-1"></i>
                                    {row.ATENDIMENTO_FINAL_FORMAT || '-'}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
export default DoctorServicePatientsView;